import {
    chakra,
    Flex,
    Text
} from '@chakra-ui/react';

import background from './icons/background.svg';

export const Container = chakra(Flex, {
    label: 'OneRoasterLandingPage - Container',
    baseStyle: {
        position: 'relative',
        m: '51px 43px',
        minH: '320px',
        border: '2px solid',
        borderColor: 'yellow.400',
        gap: '72px',
        borderRadius: '24px'
    }
});

export const IconContainer = chakra(Flex, {
    label: 'OneRoasterLandingPage - IconContainer',
    baseStyle: {
        position: 'absolute',
        bottom: 0,
        alignItems: 'center',
        justifyContent: 'center',
        w: '292px',
        h: '320px',
        backgroundImage: background
    }
});

export const IconWrapper = chakra(Flex, {
    label: 'ThreeEssentialsBadge - IconWrapper',
    baseStyle: {
        w: '136px',
        border: '2px solid #fff',
        borderRadius: '50%'
    }
});

export const IconSvg = chakra(Flex, {
    label: 'ThreeEssentialsBadge - IconSvg',
    baseStyle: {
        justifyContent: 'center',
        bg: 'primary.50',
        minW: '136px',
        h: '136px',
        backgroundColor: 'primary.25',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'visible',
        ['svg, svg path']: {
            fill: 'var(--3p-colors-primary-500) !important',
            stroke: 'var(--3p-colors-primary-500) !important'
        }
    }
});

export const Title = chakra(Text, {
    label: 'OneRoasterLandingPage - Title',
    baseStyle: {
        fontSize: '40px',
        color: 'primary.700',
        fontWeight: 400,
        lineHeight: '130%'
    }
});

export const Description = chakra(Flex, {
    label: 'OneRoasterLandingPage - Description',
    baseStyle: {
        flex: 1,
        fontSize: '20px',
        color: 'neutral.600',
        fontWeight: 400,
        lineHeight: '144%',
        letterSpacing: '-0.2px',
        m: '24px 0 32px 0'
    }
});

export const ContentWrapper = chakra(Flex, {
    label: 'ThreeEssentialsBadge - ContentWrapper',
    baseStyle: {
        ml: '365px',
        p: '24px 0',
        flexDirection: 'column',
        justifyContent: 'space-between'
    }
});

